import { defineNuxtRouteMiddleware } from 'nuxt/app';
import { tabBarNavigateStore } from '~/modules/tabBar/stores/tabBarNavigateStore';
import { ABOUT_SEGMENT, CHECKOUT_SEGMENT, HELP_SEGMENT, INFO_SEGMENT, PRODUCT_SEGMENT, SEARCH_SEGMENT } from '~/modules/tabBar/configs/tabBarConfig';

export default defineNuxtRouteMiddleware((to, from) => {
  const tabBarStore = tabBarNavigateStore();

  if (import.meta.client) {
    if (!tabBarStore.isRouteBlocked) {
      // if (process.dev) console.log('🚩Флаг не установлен, записан новый route в history');

      /** todo
       * Временная реализация задумки Кирилла
       */
      const protectedPaths = ['/product/', '/checkout/', '/search/', '/info/', '/about/', '/help/'];
      const isProtectedPath = protectedPaths.some((path) => to.path.startsWith(path));

      if (isProtectedPath) {
        tabBarStore.addStepToHistory(tabBarStore.formattedRouteByIRouteItem(from.fullPath));

      } else {
        tabBarStore.addStepToHistory(tabBarStore.formattedRouteByIRouteItem(from.fullPath));
        const searchSegmentByPath = tabBarStore.searchSegmentByPath(to.fullPath);

        if (
          searchSegmentByPath
          && searchSegmentByPath !== PRODUCT_SEGMENT
          && searchSegmentByPath !== CHECKOUT_SEGMENT
          && searchSegmentByPath !== SEARCH_SEGMENT
          && searchSegmentByPath !== INFO_SEGMENT
          && searchSegmentByPath !== ABOUT_SEGMENT
          && searchSegmentByPath !== HELP_SEGMENT
        ) {
          tabBarStore.clearAllHistoryInSegmented(searchSegmentByPath);
        }

        tabBarStore.setupActiveSegment(to);
      }
      /** todo end
       *
       * // tabBarStore.addStepToHistory(tabBarStore.formattedRouteByIRouteItem(from.path));
       * **/

    } else {
      tabBarStore.isRouteBlocked = false;
    }
  }

  /**
   * Debug
   */
  // if (import.meta.dev && import.meta.client) {
  //   const segmentedHistory = tabBarStore.segmentedHistory;
  //   const formattedData = Object.values(segmentedHistory).map((item) => {
  //     return item ? {
  //       path: item.path,
  //       segment: item.segment,
  //       code: item.code,
  //       scrollYTop: item.scrollYTop,
  //       // Для лучшей читаемости превращаем массив `values` в строку JSON
  //       values:
  //       item.values?.map((value) => ({
  //         path: value.path,
  //         segment: value.segment,
  //         code: value.code,
  //         scrollYTop: value.scrollYTop,
  //       }),
  //       ),
  //     } : undefined;
  //   });
  //   console.table(formattedData);
  //   console.log(`%cАктивный сегмент: ${tabBarStore.activeSegment}`, 'color: yellow; font-weight: bold;');
  // }
});
